export default {
  每月: "mensal",
  季度: "trimestral",
  全年: "Annual",
  計算: "Cálculo",
  新公司計算器: "Calculadora para abertura de empresa",
  "2020所得補充稅模擬計算":
    "Simulação do cálculo do Imposto Complementar de Rendimentos 2021 - 2022",
  "2021個人職業所得稅計算器":
    "Simulação do cálculo do Imposto Profissional mensal para 2023",
  "65歲以下": "Com idade inferior a 65 anos",
  "2021年度剛滿65歲": "Atingiu a idade de 65 anos no ano de 2022",
  "65歲以上/殘疾人士": "Com idade superior a 65 anos/Pessoas com invalide",
  "A.每月總收益（包括不課稅收益）":
    "A.Rendimento mensal (incluindo a matéria não colectável) ",
  "A.季度總收益（包括不課稅收益）":
    "A.Rendimento trimestral (incluindo a matéria não colectável)",
  "A.全年總收益（包括不課稅收益）":
    "A.Rendimento total (incluindo a matéria não colectável)",
  "B.不屬課稅收益": "B.Matéria não colectável",
  "C.固定扣除，相當於對B項扣減後之工作收益之25%":
    "C.Dedução fixa correspondente a 25% dos rendimentos do trabalho apurado após o abatimento referido a B [(A-B) x 25%]",
  "D.每月可課稅收益": "D.Rendimento colectável mensal (A - B - C)",
  "D.季度可課稅收益": "D.Rendimento colectável trimestral (A - B - C)",
  "D.全年可課稅收益": "D.Rendimento colectável Annual (A - B - C)",
  出生年份: "Ano de Nascimento",
  時間: "Tempo",
  註冊資本: "Registered Capital",
  由: "De",
  至: "Até",
  稅率: "Taxas",
  該級可課稅收益: "Rendimento Colectável do Escalão",
  可課稅收益: "Rendimento Colectável ",
  該級稅款: "Imposto do Escalão",
  累計稅款: "Imposto Devido",
  根據法定稅率計出之每月稅款:
    "E.Imposto mensal calculado conforme as taxas do imposto profissional ",
  根據法定稅率計出之季度稅款:
    "E.Imposto trimestral calculado conforme as taxas do imposto profissional ",
  根據法定稅率計出之全年稅款:
    "E.Imposto Annual calculado conforme as taxas do imposto profissional ",
  "根據有關年度財政預算案對職業稅稅額之30%扣減優惠":
    "F.Dedução fixa correspondente a 30% do imposto calculado nos termos da Lei do Orçamento relativa aos anos a que se respeitam (E x 30%)",
  每月應繳職業稅稅款: "G.Imposto Profissional mensal devido (E - F) ",
  季度應繳職業稅稅款: "G.Imposto Profissional trimestral devido (E - F) ",
  全年應繳職業稅稅款: "G.Imposto Profissional Annual devido (E - F) ",
  "(1)計算結果僅供參考。而確定性可課稅金額以稅務當局所作之評定為準。":
    "O resultado calculado é apenas para referência. O valor tributável definitivo será fixado pela administração fiscal.",
  "(2)不足一元的部分，作一元計。":
    "Só arredondado,  por excesso,  para a unidade da pataca.",
  "(3)不足一元的部分，作一元計。":
    "Será arredondado, por excesso, para a unidade da pataca.",
  "B.應繳所得補充稅稅款": "B. Colecta do imposto complementar",
  "A. 年度之可課稅收益": "A. Rendimento Colectável Anual",
  "(2)僅適用於2020年度取得的收益。":
    "Só é aplicado aos rendimentos auferidos nos exercícios 2020.",

  simpleVueValidator_required: "Obrigatório",
  simpleVueValidator_integer: "O valor de entrada deve ser um número inteiro",
  simpleVueValidator_greaterThenZero:
    "O número relevante não pode ser negativo",
  simpleVueValidator_over_three_million: "Mais de 3 milhões",
  stamp_duty_transfer:
    "Simulação do cálculo do Imposto do Selo (Transmissão de Bens)",
  bought_value: "Preço da Aquisição:",
  mop: "MOP",
  house_record_value: "Valor Matricial :",
  please_input_int_amt: "Favor de inserir os valores inteiros.",
  confirm_transfer: "Transmissão Definitiva",
  confirm_middle_transfer:
    "Transmissão Definitiva(Houve Transmissão Intercalar)",
  from: "De",
  till: "Até",
  tax_rate: "Taxas",
  tax_amt: "Valor Tributável",
  level_tax: "Imposto do Escalão",
  sub_tax_amt: "Imposto Devido",
  property_transfer_stamp_duty: "Imposto do Selo por transmissões de bens",
  voucher_stamp_duty: "Selo do conhecimento",
  total_tax_amt: "Imposto Total a Pagar",
  calculate: "Cálculo",
  ahead_1: "acima de ",
  ahead_2: "",
  remark_1:
    "O resultado calculado é apenas para referência. O valor tributável definitivo será fixado pela administração fiscal.",
  remark_2: "Será arredondado, por excesso, para a unidade da pataca.",
  remark_3:
    "A taxa aplicada aos prédios arrendados é de 8% sobre o rendimento colectável.",
  remark_3_1:
    "A taxa aplicada aos prédios não arrendados é de 6% sobre o rendimento colectável.",
  transfer_real_estate_stamp_duty:
    "Simulação do cálculo do Imposto do selo especial sobre a transmissão de bens imóveis",
  sale_value: "Preço da venda",
  calculate_transfer_stamp_duty_from_one_year:
    "Transmissão ocorrida no prazo de um ano a contar da data da liquidação do imposto do selo por transmissões de bens",
  calculate_transfer_stamp_duty_from_two_year:
    "Transmissão ocorrida no segundo ano a contar da data da liquidação do imposto do selo por transmissões de bens",
  house_tax_calculator:
    "Simulação do cálculo da Contribuição Predial Urbanapara o exercício de 2020 - 2022",
  house_for_rent: "Prédio arrendado",
  house_not_for_rent: "Prédio não arrendado",
  if_macau_id_holder: "O proprietário é titular do BIR da RAEM?",
  please_select: "por favor escolha",
  yes: "sim",
  no: "não",
  real_estate_type: "Finalidade do imóvel:",
  residential: "Habitação",
  business: "Hoteleira e similar, escritorios, comercial e industrialis",
  other: "Outros",
  rent_value: "Renda Anual",
  M7_manage_value:
    "Despesas de conservação e manutenção declaradas (M/7 - 'Contribuição Predial - Despesas de conservação e manutenção')",
  tax_revenue: "Rendimento Colectável",
  tax: "Colecta",
  except_house_tax:
    "Isenção da Contribuição Predial Urbana nos termos da Lei do Orçamento relativa ao ano a que se respeita",
  rent_stamp_duty: "Imposto do selo devido por arrendamento",
  expect_rent_value: "Valor estimado do aluguel anual",
  company_tax_calculate:
    "Tabela de Cálculo do Imposto sobre o Rendimento das Pessoas Colectivas",
  company_type: "Tipo de empresa",
  normal_company: "Pessoas Colectivas Comuns",
  non_resident_company: "Pessoas Colectivas Não Residentes",
  high_tech_company:
    "Empresas com capital de Macau que preencham os requisitos para o estabelecimento em Guangdong e empresas de Alta tecnologia",
  low_profit_company: "Pequena Sociedade de Baixo Lucro",
  expect_tax_value: "Valor do Rendimento Tributável",
  expect_personal_tax: "O imposto de renda de pessoa física deve ser pago",
  personal_tax: "Imposto sobre o Rendimento das Pessoas Singulares",
  company_tax: "Imposto sobre o Rendimento das Pessoas Colectivas",
  over_one_million: "Parte igual ou inferior a 1.000.000 do rendimento",
  between_one_million_and_three_million:
    "Rendimento Tributável >1.000.000~≤ 3.000.000",
  needed_tax: "Imposto sobre o Rendimento",
  remark: "Nota:",
  remark_6:
    "De acordo com a“Lei Tributária sobre o Rendimento das Pessoas Colectivas da República Popular da China”, sociedades estabelecidas por não residentes sem órgão ou sede física no território chinês, ou que não apresentam uma relação efectiva entre o seu rendimento obtido e a natureza de órgão ou sede física estabelecido, deve ser tributado o seu rendimento obtido no território chinês conforme o regime fiscal sobre o rendimento das pessoas colectivas em vigor.",
  remark_7:
    "De acordo com o 'Comunicado de Esclarecimento sobre a Implementação de Política Universal de Redução e Isenção do Imposto sobre o Rendimento das Pequenas Sociedades de Baixo Lucro', são classificadas de pequenas sociedades de baixo lucro as empresas que operam em sectores não restritos e não proibidos pelo Estado e que satisfaçam as seguintes três condições: obtenham um rendimento anual tributável ",
  remark_7_1: "não superior a 3 milhões",
  remark_7_2: ", tenham um quadro de funcionários ",
  remark_7_3: "não superior a 300 pessoas",
  remark_7_4: " e detenham um património total ",
  remark_7_5: "não superior a 50 milhões",
  remark_7_6: ".",
  remark_8:
    "A Política Preferencial de Redução e Isenção do Imposto é actualmente válido até 31 de ",
  remark_8_1: "Dezembro de 2021",
  remark_8_2: ".",
  disclaimer1:
    "O valor do rendimento tributável da tabela acima refere-se ao valor após a regularização das obrigações tributárias.",
  disclaimer2:
    "A tabela acima não reflecte o procedimento real adoptado pelas autoridades competentes e entidades certificadas de contabilidade na colecta/avaliação fiscal, servindo apenas de referência.",
  personal_tax_calculate:
    "Tabela de Cálculo do Imposto sobre o Rendimento das Pessoas Singulares (IRS)",
  personal_tax_per_year:
    "Tabela de Cálculo do Imposto sobre o Rendimento das Pessoas Singulares (Aplicável ao rendimento geral obtido por cada sujeito passivo residente - por ano)",
  personal_tax_per_year_non_chinese:
    "Tabela de Cálculo do Imposto sobre o Rendimento das Pessoas Singulares (Aplicável ao rendimento geral obtido por cada sujeito passivo não residente - por mês/ganho)",
  personal_tax_company:
    "Tabela de Cálculo do Imposto sobre o Rendimento das Pessoas Singulares (Apliável ao rendimento de actividades)",
  personal_tax_other:
    "Tabela de Cálculo do Imposto sobre o Rendimento das Pessoas Singulares (Apliável ao rendimento de juros, dividendos, bónus, bens alocados e alienação de bens e rendimentos ocasionais)",
  remark_personal_per_year_1:
    "De acordo com a “Lei Tributária sobre o Rendimento das Pessoas Colectivas da República Popular da China”, o rendimento geral de um sujeito passivo residente inclui o rendimento proveniente de salário e remuneração de trabalho dependente, rendimento proveniente de trabalho independente, rendimento de direito de publicação e rendimento de royalties. Especificamente, o valor efectivo de rendimento tributável para o rendimento proveneinte de trabalho independente, direito de publicação e de royalties, é calculado com uma redução em 20% do seu valor original. O valor efectivo de rendimento tributável para o rendimento proveniente de direito de publicação é calculado com uma redução em 70% do seu valor original.",
  remark_personal_1:
    "Os indivíduos com residência fixa no território chinês, ou sem residência fixa mas com um período de permanência no país equivalente a 183 dias em termos acumulativos durante um ano fiscal, são considerados sujeitos passivos residentes. Os sujeitos passivos residentes com rendimento obtido dentro e fora do território nacional, têm obrigação de contribuir, de acordo com a lei, o imposto sobre o rendimento das pessoa singulares. Os indivíduos não residentes e sem residência fixa no território chinês, ou sem residência fixa e apresentando um período de permanência no país inferior a 183 dias em termos acumulativos durante um ano fiscal, são considerados sujeitos passivos não residentes. Os sujeitos passivos não residentes com rendimento obtido dentro do território nacional, têm obrigação de contribuir, de acordo com a lei, o imposto sobre o rendimento das pessoas singulares.",
  remark_personal_non_chinese:
    "De acordo com a “Lei Tributária sobre o Rendimento das Pessoas Colectivas da República Popular da China”, o rendimento proveniente de salário e remuneração de trabalho dependente, rendimento proveniente de trabalho independente, rendimento de direito de publicação e rendimento de royalties obtidos por um sujeito passivo não residente, o seu cálculo do imposto sobre o rendimento das pessoas singulares é baseado em uma frequência mensal ou por cada ganho obtido. Especificamente, o valor efectivo de rendimento tributável para o rendimento proveniente de trabalho independente, direito de publicação e de royalties, é calculado com uma redução em 20% do seu valor original. O valor efectivo de rendimento tributável para o rendimento proveniente de direito de publicação é calculado com uma redução em 70% do seu valor original.",
  remark_personal_disclaimer:
    "O presente cálculo não abrange deduções, para que serve apenas para efeito de referência.",
  revenue_year: "Receita (Valor anual)",
  cost_year: "Custo (Valor anual)",
  expense_year: "Despesa (Valor anual)",
  loss_year: "Prejuízo (Valor anual)",
  CEL_year: "Custo、Despesa、Prejuízo(Valor anual)",
  remark_personal_company:
    "Aplicável ao rendimento proveniente de actividades de produção e gestão das entidades comerciais em nome individual e ao rendimento proveniente das operaçoes atraves de contracto de empreitada ou de contracto de locação das entidades empresariais e instituicionais.",
  unit_RMB: "Moeda: RMB",
  dividends: "Rendimento de juros, dividendos e bónus",
  property_for_rent: "Rendimento de bens alocados",
  property_for_transfer: "Rendimento de alienação de bens",
  property_transfer_revenue: "Receita proveniente de alienação de bens",
  property_origin_amount: "Valor original de bens",
  reasonable_expense: "Despesas razoáveis",
  incident_income: "Rendimentos ocasionais",
  total: "Valor total",
  disclaimer_GBP_1:
    "Para mais detalhes sobre as normas regulamentares de deduções, isenções e reduções do Imposto sobre o Rendimento das Pessoas Singulares, por favor consulte as respectivas políticas em vigor.",
  disclaimer_GBP_2:
    "O resultado obtido pelo presente simulador de cálculo serve apenas de referência. No cumprimento das obrigações tributárias específicas, por favor tenha em consideração o disposto das leis, regulamentos e actos normativos fiscais em vigor.",
  disclaimer_GBP_3:
    "A tabela acima não reflecte o procedimento  real adoptado pelas autoridades competentes e entidades certificadas de contabilidade na colecta/avaliação fiscal, servindo apenas de referência.",
  total_income_amount: "Rendimento Global",
  salary_income: "Salário e remuneração de trabalho dependente",
  remuneration_income: "Rendimento de trabalho independente",
  manuscript_income: "Rendimento de direito de publicação",
  royalties_income: "Rendimento de royalties",
  social_insurance: "Benefícios de Seguro Social",
  deductions:
    "Deduções especiais adicionais e outras deduções determinadas pela lei",
  per_month: "mensal",
  per_time: "por ganho",
  tax_amount: "Valor de contribuição",
  register_capital_limit_25000:
    "O Valor de Capital mínimo é de MOP $ 25.000,00 e não há limite máximo",
  notarization_fee: "Emolumentos notário",
  notarial_stamp_duty_2021:
    "Imposto do Selo dos instrumentos notariais(Em vigor em 31 de março de 2021)",
  registration_certificate_fee:
    "Certidão de admissibilidade de firma(Cada vez) montante fixo MOP 65",
  company_registration: "Registo commercial",
  main_cost_setup_company:
    "O principal custo de criação de uma empresa é sobre",
  simpleVueValidator_can_divided_by_100: "Deve ser um múltiplo de 100",
  simpleVueValidator_only_year:
    "Insira a data de nascimento, formato: ano / mês / dia",
  above: "acima de",
  incomeTax_discount:
    "Dedução fixa do imposto calculado nos termos da Lei do Orçamento relativa aos anos a que se respeitam (a dedução à colecta de $300,000)",
  incomeTax_allYear: "Imposto anual devido (B – C)",
};
